import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const Curve: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 33 267"
    sx={{
      width: '33px',
      height: '267px',
      fill: 'none',
      color: '#B4EB56',
      ...sx,
    }}
    {...props}
  >
    <path
      d="M32.2891 0.169925L0.289082 44.1699L0.289062 266.17"
      stroke="url(#paint0_linear_12119_18318)"
      strokeWidth="0.575508"
      strokeDasharray="1.53 1.53"
    />
    <defs>
      <linearGradient
        id="paint0_linear_12119_18318"
        x1="16.2891"
        y1="266.17"
        x2="16.2891"
        y2="0.169923"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.158654" stopColor="#232323" stopOpacity="0.78" />
        <stop offset="0.903846" stopColor="#B4EB56" stopOpacity="0.15" />
      </linearGradient>
    </defs>
  </SvgIcon>
);

export const MiddleLine: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 1 635"
    sx={{
      width: '1px',
      height: '635px',
      fill: 'none',
      color: '#B4EB56',
      ...sx,
    }}
    {...props}
  >
    <path
      d="M0.289062 0L0.28909 635"
      stroke="url(#paint0_linear_12119_18322)"
      strokeWidth="0.575508"
      strokeDasharray="1.53 1.53"
    />
    <defs>
      <linearGradient
        id="paint0_linear_12119_18322"
        x1="0.789062"
        y1="-2.18557e-08"
        x2="0.78909"
        y2="635"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.158654" stopColor="#232323" stopOpacity="0.78" />
        <stop offset="0.903846" stopColor="#B4EB56" stopOpacity="0.15" />
      </linearGradient>
    </defs>
  </SvgIcon>
);
